/**
 * R4: Централизованная обработка ошибок API
 */

import { toast } from 'sonner';
import { logError, ErrorType } from '@/utils/debugLogger';

/**
 * Извлекает сообщение об ошибке из response
 */
export const getErrorMessage = (error) => {
  if (!error) return null;
  if (error.response?.data?.detail) {
    return error.response.data.detail;
  }
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  if (error.message) {
    return error.message;
  }
  return 'Произошла неизвестная ошибка';
};

/**
 * Показывает toast с ошибкой + логирует в Debug Panel
 */
export const showError = (error, fallbackMessage = 'Произошла ошибка') => {
  const message = getErrorMessage(error);
  toast.error(message || fallbackMessage);

  // Логируем в Debug Panel
  const status = error?.response?.status;
  const url = error?.config?.url;
  const type = url ? ErrorType.API : ErrorType.JS;
  logError(type, `${message || fallbackMessage}${url ? ` (${url})` : ''}${status ? ` [${status}]` : ''}`, {
    status,
    url,
    fallbackMessage,
  });
};

/**
 * Показывает toast с успехом
 */
export const showSuccess = (message) => {
  toast.success(message);
};

/**
 * Показывает toast с предупреждением
 */
export const showWarning = (message) => {
  toast.warning(message);
};

/**
 * Обёртка для API вызовов с обработкой ошибок
 */
export const apiCall = async (fn, options = {}) => {
  const { 
    onSuccess, 
    onError, 
    successMessage, 
    errorMessage = 'Произошла ошибка',
    showSuccessToast = false,
    showErrorToast = true 
  } = options;

  try {
    const result = await fn();
    
    if (showSuccessToast && successMessage) {
      showSuccess(successMessage);
    }
    
    if (onSuccess) {
      onSuccess(result);
    }
    
    return { data: result, error: null };
  } catch (error) {
    if (showErrorToast) {
      showError(error, errorMessage);
    }
    
    if (onError) {
      onError(error);
    }
    
    return { data: null, error };
  }
};
